/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity } from "react-native";

import { IssueCategoryType } from "graphql/internal/generated";
import { Text } from "UpduoLibrary";
import { skaleWhite, upduoSecondLightestGray } from "config/UpduoColors";

const categoryMenuHeight = 49;

interface CategoryMenuOptionProps {
  value: IssueCategoryType;
  description: string;
  onFinish: (choice: IssueCategoryType) => void;
  isLast: boolean;
}

export default function CategoryMenuOption({
  value,
  description,
  onFinish,
  isLast = false,
}: CategoryMenuOptionProps) {
  return (
    <TouchableOpacity
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 10,
        borderColor: upduoSecondLightestGray,
        borderWidth: 1,
        borderBottomWidth: isLast ? 1 : 0,
        height: categoryMenuHeight,
        backgroundColor: skaleWhite,
      }}
      onPress={() => {
        onFinish(value);
      }}
    >
      <Text style={{ marginLeft: 5 }}>{description}</Text>
    </TouchableOpacity>
  );
}
